import { Group } from "@mantine/core"
import { AgencyOperationsAdminVenueAreaTabs } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaTabs"
import { EditAgencyOperationsAdminVenueAreaAction } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { AgencyOperationsAdminVenueAreaView } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaView"

export function AgencyOperationsAdminVenueArea() {

    const { currentItem } = useAppState(state=>state.areas)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminVenueAreaTabs/>
            <AgencyOperationsAdminVenueAreaView/>
        </PageLayout>
    )

}